import { render, staticRenderFns } from "./OrderReturnStatusBadge.vue?vue&type=template&id=f03e806e"
import script from "./OrderReturnStatusBadge.vue?vue&type=script&lang=js"
export * from "./OrderReturnStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports